import { AuditableEntity } from './auditable-entity';
import { EditableEntity } from './editable-entity';
import { ViewModel } from './view-model';

/**
 * Base class for viewmodels/entities
 */
export class BusinessEntity implements ViewModel, EditableEntity, AuditableEntity {

  public friendlyTypeNameSingular: string;
  public apiRoute: string;

  canAdd: boolean;
  canEdit: boolean;
  canDelete: boolean;

  public createdBy: string;
  public creationDate: string;
  public lastModifiedBy: string;
  public lastModifiedDate: string;

  public json(): any {
    return this;
  }

  public loadFromJson(data) {
    this.createdBy = data.createdBy;
    this.creationDate = data.creationDate;
    this.lastModifiedBy = data.lastModifiedBy;
    this.lastModifiedDate = data.lastModifiedDate;
  }

  /**
   * Override this method to set can add, edit & delete properties
   */
  public setPermissions() { }
}
